import React, { useState } from 'react'
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FormatOption, orientationOption, tableWidthOptions } from '../../utils/PdfOrientationDropdownOptions';

const ExportToPDFModal = (props: any) => {
    const { isOpen, onClose, onSubmit } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [orientationValue, setOrientationValue] = useState('landscape');
    const [formatValue, setFormatValue] = useState('a4');
    const [tableWidthValue, setTableWidthValue] = useState('auto');

    const handleSubmitForm = () => {
        const payload = {
            orientation: orientationValue,
            format: formatValue,
            tableWidth: tableWidthValue
        }
        onSubmit(payload)
    }

    return (
        <>
            <div className='card-body'>
                <div className="modal drawer-overlay" style={{ display: 'block' }}>
                    <div className="modal-dialog" style={{ maxWidth: '550px' }}>
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: '.6rem .6rem' }}>

                                <h5 className="modal-title mainHeading">{getValueFromResource('Export To PDF', dispatch, t)}</h5>
                                <div
                                    className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                    onClick={onClose}
                                >
                                    <KTSVG
                                        path="/media/icons/duotune/arrows/arr061.svg"
                                        className="svg-icon svg-icon-1x"
                                    />
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='mb-2'>
                                    <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Page Size', dispatch, t)} <i style={{marginLeft: '2px'}} className="bi bi-info-circle me-2" data-tooltip-id="tooltip-info" data-tooltip-content={getValueFromResource('Select the paper size for PDF printing.', dispatch, t)}></i></label>
                                    <Select
                                        value={FormatOption.find((option) => option.value === formatValue)}
                                        onChange={(option: any) => setFormatValue(option.value)}
                                        options={FormatOption}
                                        styles={dropDownSelectionStyles}
                                        menuPlacement="auto"
                                    />
                                </div>
                                <div className='mb-2'>
                                    <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Orientation', dispatch, t)} <i style={{marginLeft: '2px'}} className="bi bi-info-circle me-2" data-tooltip-id="tooltip-info" data-tooltip-content={getValueFromResource('Choose how the page is oriented when printing the PDF.', dispatch, t)}></i></label>
                                    <Select
                                        value={orientationOption.find((option) => option.value === orientationValue)}
                                        onChange={(option: any) => setOrientationValue(option.value)}
                                        options={orientationOption}
                                        styles={dropDownSelectionStyles}
                                        menuPlacement="auto"
                                    />
                                </div>
                                <div>
                                    <label className="form-label fs-7 fw-normal mb-2">
                                        {getValueFromResource('Column Layout', dispatch, t)}
                                        <i
                                            style={{marginLeft: '2px'}}
                                            className="bi bi-info-circle me-2"
                                            data-tooltip-id="tooltip-info"
                                            data-tooltip-html={`
                                                <ul style="padding-left: 16px; margin: 0;">
                                                    <li>${getValueFromResource(
                                                'Auto-Fit Columns: Adjusts column widths to fit the page automatically.',
                                                dispatch,
                                                t
                                            )}</li>
                                                <li>${getValueFromResource(
                                                'Fixed-width Columns: Keeps columns width unchanged when printing.',
                                                dispatch,
                                                t
                                            )}</li>
                                            </ul>
                                            `}
                                        ></i>
                                    </label>
                                    {/* <label className="form-label fs-7 fw-normal mb-2">{getValueFromResource('Column Layout', dispatch, t)} <i className="bi bi-info-circle me-2"  data-tooltip-id="tooltip-info" data-tooltip-content={getValueFromResource(`${tableWidthValue === 'wrap' ? 'Fixed-width column: Keeps columns width unchanged when printing' : 'Adjusts column widths to fit the page automatically'}`, dispatch, t)}></i></label> */}
                                    <Select
                                        value={tableWidthOptions.find((option) => option.value === tableWidthValue)}
                                        onChange={(option: any) => setTableWidthValue(option.value)}
                                        options={tableWidthOptions}
                                        styles={dropDownSelectionStyles}
                                        menuPlacement="auto"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                    onClick={onClose}
                                >
                                    {getValueFromResource('Cancel', dispatch, t)}

                                </button>
                                <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={handleSubmitForm}>
                                    {getValueFromResource('Export', dispatch, t)}

                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReactTooltip
                id="tooltip-info"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 999999,
                    maxWidth: 220,
                    whiteSpace: 'normal'
                }}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable={true}
            />
        </>
    )
}

export default ExportToPDFModal